import React from "react";
import { Phone, MessageSquareQuote } from "lucide-react";

export default function MobileBar({ site }) {
  return (
    <div
      data-testid="mobile-bottom-bar"
      style={{ zIndex: 2147483647 }}
      className="lg:hidden fixed bottom-0 inset-x-0 bg-[#0A0A0A] border-t border-[#D4AF37]/30 rounded-t-3xl shadow-[0_-12px_40px_-10px_rgba(0,0,0,0.35)] px-4 py-3"
    >
      <div className="grid grid-cols-2 gap-3">
        <a
          href={site?.phone_href || "#"}
          data-testid="mobile-call-btn"
          className="inline-flex items-center justify-center gap-2 w-full px-3 py-3 rounded-full bg-white text-[#0A0A0A] font-display font-bold text-[11px] uppercase tracking-wider border border-[#D4AF37]/40 hover:bg-[#FBF8F1] transition-all"
        >
          <Phone className="w-4 h-4 text-[#B8941F]" /> Call Now
        </a>
        <a href="#contact" data-testid="mobile-quote-btn" className="btn-gold !py-3 !text-[11px] !px-3 w-full">
          <MessageSquareQuote className="w-4 h-4" /> Get Quote
        </a>
      </div>
    </div>
  );
}
